<template>
    <pt-dialog
        :model-value="props.visible"
        :title="t('experience.common.delete_title_confirm')"
        :append-to-body="true"
        width="580px"
        custom-class="confirmation-dialog"
        @close="onClose"
    >
        <div :class="$style.dialogContent">
            <p :class="$style.des">
                {{
                    t('experience.setting.delete_template_content', {
                        name: props.template.name
                    })
                }}
            </p>
        </div>
        <template #footer>
            <pt-button :class="$style.cancel" type="contain" color="grey" @click="onClose">{{
                t('common.button_cancel')
            }}</pt-button>
            <pt-button color="red" class="pt-ml8" @click="onConfirm">{{
                t('common.button_confirm')
            }}</pt-button>
        </template>
    </pt-dialog>
</template>

<script lang="ts">
export default {
    name: 'ExperienceTemplateDeleteDialog'
};
</script>

<script lang="ts" setup>
import type { ExperienceTemplateV4 } from '@models/experience/useExperienceTemplatesV4';
import { useI18n } from 'vue-i18n';
// interface
interface Props {
    visible: boolean;
    template: ExperienceTemplateV4 | null;
}
// props
const props = defineProps<Props>();
// emits
const emit = defineEmits(['close', 'confirm']);

const { t } = useI18n();

// function
function onClose() {
    emit('close');
}

function onConfirm() {
    emit('confirm', props.template);
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
</style>
